import React from 'react'
import AboutUsWelcome from './sections/AboutUsWelcome/AboutUsWelcome'
import Vision from './sections/Vision/Vision'
import History from './sections/History/History'
import AboutUsLiveLinks from './sections/Mission/AboutUsLiveLinks'


const AboutUs = () => {
  return (
    <>
    <AboutUsWelcome/>
    <AboutUsLiveLinks/>
    <Vision/>
    <History/>
    </>
  )
}

export default AboutUs
